var _style, _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _g, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTdrMin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 257.9",
    style: {
      enableBackground: "new 0 0 300 257.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#303030;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#BCBEC0;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#303030;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 40.8,
    className: "st0",
    width: 144.1,
    height: 82.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.4,67.5h-10.3v-2.1h10.3V67.5z M119.9,67.5h-10.3v-2.1h10.3V67.5z M103.3,67.5H93.1v-2.1h10.3V67.5z  M86.9,67.5H76.6v-2.1h10.3V67.5z M70.5,67.5H60.1v-2.1h10.3v2.1H70.5z M53.9,67.5H43.6v-2.1h10.3V67.5z M37.4,67.5H27.2v-2.1h10.3 V67.5z M21,67.5H10.7v-2.1H21V67.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.4,94.9h-10.3v-2.1h10.3V94.9z M119.9,94.9h-10.3v-2.1h10.3V94.9z M103.3,94.9H93.1v-2.1h10.3V94.9z  M86.9,94.9H76.6v-2.1h10.3V94.9z M70.5,94.9H60.1v-2.1h10.3v2.1H70.5z M53.9,94.9H43.6v-2.1h10.3V94.9z M37.4,94.9H27.2v-2.1h10.3 V94.9z M21,94.9H10.7v-2.1H21V94.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.4,119.5h-10.3v-2.1h10.3V119.5z M119.9,119.5h-10.3v-2.1h10.3V119.5z M103.3,119.5H93.1v-2.1h10.3V119.5z  M86.9,119.5H76.6v-2.1h10.3V119.5z M70.5,119.5H60.1v-2.1h10.3v2.1H70.5z M53.9,119.5H43.6v-2.1h10.3V119.5z M37.4,119.5H27.2v-2.1 h10.3V119.5z M21,119.5H10.7v-2.1H21V119.5z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 155.9,
    y: 232.9,
    className: "st2",
    width: 144.1,
    height: 23.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 155.9,
    y: 205.5,
    className: "st2",
    width: 144.1,
    height: 23.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 232.9,
    className: "st3",
    width: 144.1,
    height: 23.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 205.5,
    className: "st3",
    width: 144.1,
    height: 23.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 177.9,
    className: "st3",
    width: 144.1,
    height: 23.9
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 150.5,
    className: "st3",
    width: 144.1,
    height: 23.9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 123.1,
    className: "st3",
    width: 144.1,
    height: 23.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 155.9,
    y: 177.9,
    className: "st2",
    width: 144.1,
    height: 23.9
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 155.9,
    y: 150.5,
    className: "st2",
    width: 144.1,
    height: 23.9
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 155.9,
    y: 123.1,
    className: "st2",
    width: 144.1,
    height: 23.9
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 155.7,
    y: 95.7,
    className: "st3",
    width: 144.3,
    height: 23.9
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 155.7,
    y: 68.2,
    className: "st3",
    width: 144.3,
    height: 23.9
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 155.7,
    y: 40.8,
    className: "st3",
    width: 144.3,
    height: 23.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 41,
    className: "st1",
    width: 11.4,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.7,
    y: 41,
    className: "st1",
    width: 11.4,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.4,
    y: 41,
    className: "st1",
    width: 11.4,
    height: 2.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "143.2,47.8 145.2,47.8 145.2,41 138.5,41 138.5,43 143.2,43  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.2,
    y: 110.7,
    className: "st1",
    width: 2.1,
    height: 8.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.2,
    y: 73.2,
    className: "st1",
    width: 2.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.2,
    y: 92,
    className: "st1",
    width: 2.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.2,
    y: 54.4,
    className: "st1",
    width: 2.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.7,
    y: 41,
    className: "st1",
    width: 11.4,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 92,
    className: "st1",
    width: 2.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 54.4,
    className: "st1",
    width: 2.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 73.2,
    className: "st1",
    width: 2.1,
    height: 12.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 110.7,
    className: "st1",
    width: 2.1,
    height: 8.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3.5,43 8.3,43 8.3,41 1.5,41 1.5,47.8 3.5,47.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.2,
    y: 41,
    className: "st1",
    width: 11.4,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.9,
    y: 41,
    className: "st1",
    width: 11.4,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.6,
    y: 41,
    className: "st1",
    width: 11.4,
    height: 2.1
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.7,16.6l-7,7V1.9H72.8V23h3.5V5.4H226v18.3l-7-7l-2.4,2.4l11.2,11.2L239,19.2L236.7,16.6z M227.8,25.4 L227.8,25.4L227.8,25.4L227.8,25.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTdrMin);
export default __webpack_public_path__ + "static/media/TDR_min.c8fb386842525aff1dca60c95b97346d.svg";
export { ForwardRef as ReactComponent };